class ComponentShareIdea {
  constructor() {
    this._init();
  }

  _init() {
    const sidebar_share_idea_toggler = document.querySelectorAll(
      '[data-open-sidebar-share-idea]'
    );

    if (sidebar_share_idea_toggler) {
      sidebar_share_idea_toggler.forEach((element) => {
        element.addEventListener('click', this._toggleSidebar.bind(this));
      });
    }
  }

  _toggleSidebar() {
    const sidebar_share_idea = document.getElementById('sidebar-share-idea');
    if (sidebar_share_idea) {
      sidebar_share_idea.classList.toggle('open');

      if (sidebar_share_idea.classList.contains('open')) {
        document.body.classList.add('sidebar-open');
        const successMessage = document.querySelector('.sidebar-share-idea__success') as HTMLElement;
        const form = document.querySelector('.sidebar-share-idea__form') as HTMLFormElement;
        if (form) {
          form.style.display = 'block';
        }
        if (successMessage) {
          successMessage.style.display = 'none';
        }
      } else {
        document.body.classList.remove('sidebar-open');
      }
    }
  }

  _hideSidebar() {
    const sidebar_share_idea = document.getElementById('sidebar-share-idea');
    if (sidebar_share_idea && sidebar_share_idea.classList.contains('open')) {
      sidebar_share_idea.classList.remove('open');
      document.body.classList.remove('sidebar-open');
    }
  }

}

export const componentShareIdea = new ComponentShareIdea();
